import { Injectable } from "@angular/core";
import { environment } from "../environments/environment";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { PostCount } from "./models/post-count";
import { Author } from "./models/author";

@Injectable()
export class MetadataService {
  private apiBase: string = environment.api_base;

  constructor(private http: HttpClient) {}

  getDailyPostCount(): Observable<PostCount[]> {
    return this.http.get<PostCount[]>(`${this.apiBase}metadata/postcount/`);
    // .map(response => {
    // let results = response.json().results as PostCount[]
    // results.forEach((r=> {
    // r.date = new Date(r.date);
    // console.log(r.date.toString())
    // }))
    // return results
    // })
  }

  getHourPostCount(): Observable<PostCount[]> {
    return this.http.get<PostCount[]>(`${this.apiBase}metadata/posttime/`);
    // .map(response => {
    //   let results = response.json().results as PostCount[];
    //   results.forEach((r=> r.date = new Date(r.date)))
    //   return results
    // })
  }

  getTopRedditors(leadertype='author',start='2017-07-03',days='0'): Observable<Author[]> {
    //console.log(this.http.get<Author[]>(`${this.apiBase}metadata/top?leader=`+leadertype+`&start=`+start+'&days='+days));
    return this.http.get<Author[]>(`${this.apiBase}metadata/top?leader=`+leadertype+`&start=`+start+'&days='+days);

    // .map(response => response.json().results as Author[]
    // )
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src946329470/src/frontend/src/app/metadata.service.ts